
import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("Sucursal");
const crud = rpcCrudService<models.Sucursal, models.SucursalDTO>(controller);


export const Sucursal = cacheResource({
    ...crud,
    /**Obtiene todas las entidades filtradas por la zona */
    query: async (filtro?: models.FiltroSucursal): Promise<models.SucursalDTO[]> => await controller("Query", {}, filtro || {}),

    BySucursal: async (filtro?: models.FiltroSucursal): Promise<models.ChoferEADDto[]> => await controller("BySucursal", {}, filtro || {}),

}, {
    query: true,
    getMemo: true,
    BySucursal: true
}, {
    add: true,
    delete: true,
    update: true
});



// WEBPACK FOOTER //
// ./app/resources/items/sucursal.ts